import { Text } from '@user-portal/wikr-components';

import * as S from './styled';

import { PillProps } from './types';

const Pill = <T,>({ title, isActive, id, onClick }: PillProps<T>) => (
    <S.Pill data-locator="pill" data-testid="pill" isActive={isActive} onClick={() => onClick(id)}>
        <Text type="small-text" bold>
            {title}
        </Text>
    </S.Pill>
);

export default Pill;
